module.exports = __webpack_public_path__ + "static/media/README.9bc4ffdb.md";